import { useCallback, useEffect, useRef } from 'react';

import { useCurrentUser } from '@kanda-libs/ks-frontend-services';

import useReloadInitialData from './useReloadInitialData';

interface RefreshingDataHook {
  cleanUp: () => void;
}

export default function useRefreshingData(
  interval = 20000,
): RefreshingDataHook {
  const { isUserLoggedIn } = useCurrentUser();
  const reloadData = useReloadInitialData();

  const timerRef = useRef<NodeJS.Timer | undefined>();

  const cleanUp = useCallback(() => {
    if (!timerRef.current) return;
    clearTimeout(timerRef.current as unknown as number);
  }, []);

  useEffect(() => {
    if (!isUserLoggedIn || timerRef.current) return;
    timerRef.current = setInterval(() => {
      reloadData();
    }, interval);
  }, [isUserLoggedIn, reloadData, interval]);

  return { cleanUp };
}
